import {
  titleUI,
  currencyUI,
  currencySchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../utils/content.json';

const uiSchema = {
  ...titleUI(content['financial-info-additional-land-title']),
  homeAcreageValue: currencyUI({
    title: content['financial-info-additional-land-home-acre-title'],
    hint: content['financial-info-additional-land-home-acre-hint'],
    max: 999999999,
  }),
};

const schema = {
  type: 'object',
  required: ['homeAcreageValue'],
  properties: {
    homeAcreageValue: currencySchema,
  },
};

export default {
  uiSchema,
  schema,
};
